import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Colors from '../Colors';

export const optionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#fff',
      zIndex: 100,
      width: '100%',
    },
    formControl: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      height: 30,
      '&:hover': {
        background: '#EBEBEB',
      },
    },
    select: {
      width: 220,
      marginLeft: theme.spacing(1),
    },
    containerMulti: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    button: {
      width: 50,
      height: 50,
      paddingLeft: 10,
      paddingRight: 10,
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: '#d2d2d2',
      },
      [theme.breakpoints.down('sm')]: {
        zIndex: 160,
      },
    },
    buttonActive: {
      backgroundColor: '#e2e2e2'
    },
    responsiveCard: {
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        backgroundColor: 'white',
        display: 'flex',
        flexFlow: 'column',
        zIndex: 160,
        position: 'relative',
        width: '100%',
      },
    },
    buttonIncon: {
      height: 30,
      width: 30,
      [theme.breakpoints.down('sm')]: {
        zIndex: 160,
      },
    },
    heightContentBar: {
      height: 480,
      width: 800,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },

    },
    heightContent: {
      height: 480,
      width: 840,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    divResponsive: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        zIndex: 120,
        backgroundColor: 'white',
      },
    },
    loadingContainer: {
      display: 'flex',
      marginTop: '30px',
      justifyContent: 'center',
    },
    loadingSpinner: {
      color: Colors.main,
    },
  }),
);
